import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios from '../../resources/axios';
import { AppThunk, RootState } from '../store';
import { ScooterType, ScooterTypesState } from '../../resources/types/scooterTypesTypes';

const initialState: ScooterTypesState = {
  items: [],
  scooterType: {}
};

const scooterTypesSlice = createSlice({
  name: 'scooterTypes',
  initialState,
  reducers: {
    setScooterTypes: (state, action: PayloadAction<ScooterType[]>) => {
      state.items = action.payload;
    },
    setScooterType: (state, action: PayloadAction<Partial<ScooterType>>) => {
      state.scooterType = { ...state.scooterType, ...action.payload };
    },
    clearScooterType: (state) => {
      state.scooterType = {};
    }
  }
});

export const { setScooterTypes, setScooterType, clearScooterType } = scooterTypesSlice.actions;

export const selectScooterTypes = (state: RootState) => state.scooterTypes;

export const getScooterTypesAsync = (): AppThunk => async (dispatch) => {
  try {
    const response = await axios.get('/scooter/scooter_types');
    dispatch(setScooterTypes(response.data.data || []));
  } catch (error) {
    console.error('Error fetching scooter types:', error);
  }
};

export const createScooterTypeAsync = (): AppThunk => async (dispatch, getState) => {
  try {
    const { scooterType } = getState().scooterTypes;
    await axios.post('/scooter/scooter_types', { name: scooterType.name });
    dispatch(clearScooterType());
  } catch (error) {
    console.error('Error creating scooter type:', error);
    throw error;
  }
};

export const updateScooterTypeAsync = (): AppThunk => async (dispatch, getState) => {
  try {
    const { scooterType } = getState().scooterTypes;
    await axios.put(`/scooter/scooter_types/${scooterType._id}`, {
      name: scooterType.name
    });
    dispatch(clearScooterType());
  } catch (error) {
    console.error('Error updating scooter type:', error);
    throw error;
  }
};

export const deleteScooterTypeAsync = (id: string): AppThunk => async () => {
  try {
    await axios.delete(`/scooter/scooter_types/${id}`);
  } catch (error) {
    console.error('Error deleting scooter type:', error);
    throw error;
  }
};

export default scooterTypesSlice.reducer;
